module.exports = __webpack_public_path__ + "img/PusherBarge.5b797af1.png";